import EventBus from '@/EventBus';
import DefaultImageProps from '@/components/DesignObjects/ImageObject';
import { uuid } from 'vue-uuid';
import { getMaxZIndex } from '@/components/Helper';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';

export default {
  methods: {
    removeObjectFromCanvas() {
      console.log('Deleting object');
      const index = parseInt(this.targets[0].dataset.elementindex);
      // EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED);
      EventBus.$emit(ApplicationEventTypes.ModalEvents.TOGGLE_CONFIRMATION_MODAL, { request: 'DeleteReq', data: index, message: 'Are you sure you want to delete this?' });
    },

    changeFdicPhoto({ title, type }) {
      if (!this.activeObject || (title !== 'White' && title !== 'Black')) { return; }

      let logos = this.$store.getters.getNcuaLogos;
      if (type == 'FDIC') { logos = this.$store.getters.getFdicLogos; }

      const blackLogo = logos[0].DefaultImagePath;
      const whiteLogo = logos[1].DefaultImagePath;
      if (title === 'White') {
        this.activeObject.DefaultImageUrl = whiteLogo;
        this.activeObject.HighResPath     = whiteLogo;
        this.activeObject.ImageType       = 'FDICTextWhite';
      }
      if (title === 'Black') {
        this.activeObject.DefaultImageUrl = blackLogo;
        this.activeObject.HighResPath     = blackLogo;
        this.activeObject.ImageType       = 'FDICText';
      }
      this.emitUndoRedoRequest('Called by FDIC change');
    },
    changeHousingPhoto(data) {
      if (!this.activeObject || (data !== 'White' && data !== 'Black')) { return; }

      const logos     = this.$store.getters.getHousingLogos;
      const blackLogo = logos[0].DefaultImagePath;
      const whiteLogo = logos[1].DefaultImagePath;
      if (data === 'White') {
        this.activeObject.DefaultImageUrl = whiteLogo;
        this.activeObject.HighResPath     = whiteLogo;
        this.activeObject.ImageType       = 'FDICLogoWhite';
      }
      if (data === 'Black') {
        this.activeObject.DefaultImageUrl = blackLogo;
        this.activeObject.HighResPath     = blackLogo;
        this.activeObject.ImageType       = 'FDICLogo';
      }

      this.emitUndoRedoRequest('Called by Equal Housing change');
    },
    replaceCanvansPhoto(scr) {
      if (this.activeObject != null && this.activeObject.ImageType === 'Image') {
        // //   EventBus.$emit('showHideLoader', true);
        const img  = new Image();
        const data = this.activeObject;
        img.onload = () => {
          data.DefaultImageHeight = img.height;
          data.DefaultImageWidth  = img.width;
        };
        img.src = scr.DefaultImageUrl;

        this.activeObject.DefaultImageUrl    = scr.DefaultImageUrl;
        this.activeObject.HighResPath        = scr.HighResImageUrl;
        this.activeObject.HighResV2Height    = scr.HighResV2Height;
        this.activeObject.HighResV2Width     = scr.HighResV2Width;
        this.activeObject.croppedHighResPath = 'none';
        this.activeObject.croppedSrc         = 'none';

        this.addIntoPageWiseUndoRedoArray_MixinFun('Replace image');
      }
    },
    changeSvgFillColor(color) {
      console.log('Changing SVG Image fill');
      if (color && this.activeObject != null && this.activeObject.type === 'image' && this.activeObject.ImageType === 'SVGImage'&& !this.activeObject.isGradient) {
        const svgElement = document.querySelector(`[id='${this.activeObject.Id}'] svg`);
        this.removingStylingFromChildrenTag(svgElement, 'fill');
        if (svgElement) { svgElement.setAttribute('fill', color); }
        this.activeObject.SvgProperty.DefaultColor = color;
        const lines                                = svgElement.querySelectorAll('rect, ellipse, line, path, polygon');
        if (lines.length) {
          for (let lineIndex = 0; lineIndex < lines.length; lineIndex += 1) {
            lines[lineIndex].style.fill = color;
          }
        }
        this.activeObject.SvgProperty.content = svgElement.outerHTML;
        EventBus.$emit('updateProductColor');
        this.addIntoPageWiseUndoRedoArray_MixinFun('change SVG shape color');
      }
      else {
        const svgElement = document.querySelector(`[id='${this.activeObject.Id}'] svg`);
        if (!svgElement) return;
        this.removingStylingFromChildrenTag(svgElement, 'fill');

        let defs = svgElement.querySelector('defs');
        if (!defs) {
          defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
          svgElement.insertBefore(defs, svgElement.firstChild);
        }

        const gradientId = `gradient-${this.activeObject.Id}`;
        let gradient = svgElement.querySelector(`#${gradientId}`);

        if (!gradient) {
          gradient = document.createElementNS('http://www.w3.org/2000/svg', 'linearGradient');
          gradient.setAttribute('id', gradientId);
          gradient.setAttribute('gradientTransform', `rotate(${this.activeObject.gradient.angle})`);
          defs.appendChild(gradient);
        } else {
          gradient.setAttribute('gradientTransform', `rotate(${this.activeObject.gradient.angle})`);
          gradient.innerHTML = '';
        }

        const sortedColors = this.activeObject.gradient.colors.sort((a, b) => a.position - b.position);
        sortedColors.forEach(({ position, rgba }) => {
          const stop = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
          stop.setAttribute('offset', `${position}%`);
          stop.setAttribute('stop-color', rgba);
          gradient.appendChild(stop);
        });

        const elementsToStyle = svgElement.querySelectorAll('rect, ellipse, line, path, polygon');
        elementsToStyle.forEach((el) => {
          el.setAttribute('fill', `url(#${gradientId})`);
        });

        this.activeObject.SvgProperty.content = svgElement.outerHTML;
        EventBus.$emit('updateProductColor');
        this.addIntoPageWiseUndoRedoArray_MixinFun('change SVG shape color');
      }
    },
    changeSvgStrokeColor(color) {
      console.log('Changing SVG Stroke ');
      if (this.activeObject != null && this.activeObject.type === 'image' && this.activeObject.ImageType === 'SVGImage') {
        const svgElement = document.querySelector(`[id='${this.activeObject.Id}'] svg`);
        if (!svgElement) { return; }
        this.removingStylingFromChildrenTag(svgElement, 'stroke');
        this.activeObject.SvgProperty.StrokeColor = color;
        const lines                               = svgElement.querySelectorAll('line, path, rect, ellipse, polygon');
        if (lines.length) {
          for (let lineIndex = 0; lineIndex < lines.length; lineIndex += 1) {
            lines[lineIndex].style.stroke      = color;
            lines[lineIndex].style.strokeWidth = this.activeObject.SvgProperty.StrokeWidth;
          }
        }

        this.activeObject.SvgProperty.content = svgElement.outerHTML;
        EventBus.$emit('updateProductColor');
        this.addIntoPageWiseUndoRedoArray_MixinFun('change SVG shape color');
      }
    },
    changeStrokeWidth(value) {
      if (this.activeObject.ImageType == 'SVGImage') {
        this.activeObject.SvgProperty.StrokeWidth = parseInt(value, 10);
        this.changeSvgStrokeColor(this.activeObject.SvgProperty.StrokeColor);
      } else { this.activeObject.StrokeWidth = parseInt(value, 10); }
    },
    removingStylingFromChildrenTag(svgElement, type = 'stroke') {
      svgElement.querySelectorAll('path').forEach((item) => {
        if (type == 'stroke') { item.style.stroke = ''; }
        if (type == 'fill') { item.style.fill = ''; }
      });
      svgElement.querySelectorAll('g').forEach((item) => {
        if (type == 'stroke') { item.style.stroke = ''; }
        if (type == 'fill') { item.style.fill = ''; }
      });
    },
    replaceCanvansAddressBoxPhoto(AddressBoxesPath) {
      if (this.activeObject != null && (this.activeObject.ImageType === 'WhiteboxLogo' || this.activeObject.ImageType === 'IndependentWhitebox')) {
        this.activeObject.DefaultImageUrl = AddressBoxesPath.DefaultImagePath;
        this.activeObject.HighResPath     = AddressBoxesPath.HighResImagePath;
        setTimeout(() => { EventBus.$emit('updateProductColor'); }, 0);
        this.addIntoPageWiseUndoRedoArray_MixinFun('Replace Address Box image');
      }
    },
    addingAlternativeImageUrl(Object) {
      this.activeObject.AlternativeImageUrls.push(Object.DefaultImageUrl);
      this.addIntoPageWiseUndoRedoArray_MixinFun('Add Alternative image Url');
    },
    addIntoPageWiseUndoRedoArray_MixinFun(data) {
      EventBus.$emit(ApplicationEventTypes.UndoRedoEvents.ADDED, data);
    },
    AddNewObjectImage(newImgData) {
      EventBus.$emit('showHideLoader', true);
      const productwidth  = this.width;
      const productheight = this.height;
      const { data }      = new DefaultImageProps();
      // const objectHeight   = 'auto';
      // const temp           = Math.min(this.width, this.height);
      data.ImageType       = 'Image';
      data.DefaultImageUrl = newImgData.DefaultImageUrl;
      data.HighResPath     = newImgData.HighResImageUrl; // if highresource is null or empty then the default image replace the highe resource
      data.Name            = 'Photo';
      data.Id              = uuid.v1();
      data.PdfSortOrder    = data.SortOrder = getMaxZIndex(document.getElementById('canvas-wrapper').firstElementChild.children) + 1;
      // data.Width           = temp;
      // data.Height          = objectHeight;
      data.HighResV2Height               = newImgData.HighResV2Height;
      data.HighResV2Width                = newImgData.HighResV2Width;
      data.elementIndex                  = 0;
      data.isSelected                    = false;
      data.RotateDegree                  = 0;
      data.PageNo                        = this.activePage;
      data.isImageAddedOnCanvasFromModel = true;
      data.AlternativeImageUrlsResVersion.push(newImgData);
      const img = new Image();

      img.onload =  () => {
        // data.Height = temp * (img.height / img.width);
        // let widthRatio=img.width/img.height
        data.DefaultImageHeight = img.height;
        data.DefaultImageWidth  = img.width;
        const heightRatio       = img.height / img.width;
        data.Width              = productwidth / 1.5;
        data.Height             = Math.round(data.Width * heightRatio);
        data.X                  = Math.round(Math.abs((productwidth / 2) - data.Width / 2));
        data.Y                  = Math.round(Math.abs((productheight / 2) - data.Height / 2));
        EventBus.$emit('onObjectAdding', JSON.parse(JSON.stringify(data)));
        EventBus.$emit('showHideLoader', false);
      };
      img.onerror = () => {
        EventBus.$emit('showHideLoader', false);
      };
      img.src     = newImgData.DefaultImageUrl;
    },
    emitUndoRedoRequest(data) {
      EventBus.$emit('addIntoPageWiseUndoRedoArray', data);
    },
  },
};
